export const SOCIAL_MEDIAS = {
  FACEBOOK: 1,
  APPLE_SIGN_IN: 2,
  APPLE_GAME_CENTER: 3,
  GOOGLE_PLAY_GAMES: 4,
};